import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://bioretis.com";
const PAGES = {
  "/": [
    "BioRetis | Bioinformatics & Scientific Research",
    "BioRetis GmbH \u2013 scientific research, bioinformatics and data-driven approaches. Explore our work, publications and immunoClust."
  ],
  "/about": [
    "About BioRetis | Research & Expertise",
    "Learn about BioRetis GmbH, our team, scientific expertise and research activities."
  ],
  "/publications": [
    "Scientific Publications | BioRetis",
    "Explore scientific publications and research contributions from BioRetis."
  ],
  "/immunoclust-demo": [
    "immunoClust Demo | BioRetis",
    "Discover the immunoClust demo and learn about approaches to cytometry data analysis."
  ],
  "/legal-notice": [
    "Legal Notice | BioRetis",
    "Legal notice and company information for BioRetis GmbH."
  ],
  "/privacy": [
    "Privacy Policy | BioRetis",
    "Read the BioRetis privacy policy and information about the handling of personal data."
  ]
};
function setMeta(attribute, key, content) {
  let node = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!node) { node = document.createElement("meta"); node.setAttribute(attribute, key); document.head.appendChild(node); }
  node.setAttribute("content", content);
}
export default function SeoMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, "") || "/";
    const data = PAGES[path] || PAGES["/"];
    const canonical = BASE + (path === "/" ? "/" : path);
    document.title = data[0];
    setMeta("name", "description", data[1]);
    setMeta("property", "og:title", data[0]);
    setMeta("property", "og:description", data[1]);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", "website");
    setMeta("name", "twitter:title", data[0]);
    setMeta("name", "twitter:description", data[1]);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;
  }, [pathname]);
  return null;
}
